import React, { useRef, useState, useEffect } from 'react';
import {flowRight as compose} from 'lodash';
import { LoadingContent, queryWithLoading } from '../utilities/NSDb.js';
// import { graphql } from '@apollo/react-hoc';
// import { Query, Mutation, Subscription } from '@apollo/client/react/components';
import { useMutation, useLazyQuery, useQuery } from '@apollo/client';
import dayjs from 'dayjs';
import { useAuthUser } from 'react-auth-kit';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PlayerCardComponent } from "./player_component.js";
import { WorkoutsCardComponent } from "./workouts_component.js";
import { BenchmarksCardComponent } from "./benchmarks_component.js";

import { BenchmarksGraphComponent} from './benchmarks_graph_component.js';
import { WorkoutsGraphComponent} from './workouts_graph_component.js';

// GRAPHQL QUERY
import { 
    GetCustomers,
    GetUsers,
    GetUsersQRCodes,
    GetUsersPTCs,
    SaveUserQRCode
} from './users_graphql.js';

// DOCS: https://www.apollographql.com/docs/react/get-started/
// Import everything needed to use the `useQuery` hook
// import { useQuery, useMutation } from '@apollo/client';


// setstate array 
// setList(list.map(artwork => {
//       if (artwork.id === artworkId) {
//         return { ...artwork, seen: nextSeen };
//       } else {
//         return artwork;
//       }
//     }));

export function PlayersListComponent(props) {
    const playerRef = useRef(null);
    const auth = useAuthUser();

    const DefaultUser = {
        user_ID: 0,
        archiver_ID: 0,
        arm_length_left: '',
        arm_length_right: '',
        creator_ID: 0,
        customer_ID: 0,
        date_archived: null,
        date_birth: '',
        date_created: null,
        date_last_benchmark: null,
        date_last_workout: null,
        date_updated: null,
        email: '',
        first_name: '',
        forearm_length_left: '',
        forearm_length_right: '',
        gender: '',
        height_feet: '',
        height_inches: '',
        last_name: '',
        password: '',
        phone_number: '',
        player_number: '',
        player_position: '',
        rookie_season: '',
        school_year: '',
        sport: '',
        updater_ID: 0,
        user_name: '',
        user_type_ID: 1,
        weight: ''
    };

    const [Action, setAction] = useState('');
    const [CardOpenPlayerDetails, setCardOpenPlayerDetails] = useState(false);
    const [CardOpenWorkouts, setCardOpenWorkouts] = useState(false);
    const [CardOpenBenchmarks, setCardOpenBenchmarks] = useState(false);
    const [Customers, setCustomers] = useState([]);
    const [Players, setPlayers] = useState([]);
    const [SelectedUser, setSelectedUser] = useState({ ...DefaultUser });
    const [SelectedUserPTCs, setSelectedUserPTCs] = useState([]);
    const [SelectedUserQRCodes, setSelectedUserQRCodes] = useState([]);

    const [save_user_qr_code] = useMutation(SaveUserQRCode);

    const [get_customers] = useLazyQuery(GetCustomers, { fetchPolicy: 'network-only'});
    const [get_users_PTCs] = useLazyQuery(GetUsersPTCs, { fetchPolicy: 'network-only'});
    const [get_users_QRCodes] = useLazyQuery(GetUsersQRCodes, { fetchPolicy: 'network-only'});
    const [get_users] = useLazyQuery(GetUsers, { fetchPolicy: 'network-only'});

    // Get players with this logged in user's customer_ID
    useEffect(() => {
        // The code we want to run (on load)
        // For coach+ accounts, get all users on the account
        if ( auth().User.user_type_ID !== 1 ) {
            get_users({ variables: { customer_ID: parseInt(auth().User.customer_ID), archiver_ID: 0, user_type_ID: 1 } }).then(
                res => {
                    console.log("users: ", res.data.users)
                    setPlayers(res.data.users);

                    // Get all customers to display if this is the Super Admin account
                    if ( parseInt(auth().User.customer_ID) === 1 ) {
                        let TempPlayers = res.data.users;
                        get_customers({ variables: { customer_ID: parseInt(auth().User.customer_ID), archiver_ID: 0, user_type_ID: 1 } }).then(
                            res => {
                                let TempCustomers = [...res.data.customers];
                                console.log({TempCustomers})
                                TempCustomers = TempCustomers.map((C) => {
                                    return { ...C, Players: TempPlayers.filter((U) => parseInt(U.customer_ID) === parseInt(C.customer_ID))}
                                });
                                setCustomers(TempCustomers);
                            }
                        );
                    } 
                }
            );
        } else if ( auth().User.user_type_ID === 1 ) {
            console.log("IN")
            get_users({ variables: { customer_ID: parseInt(auth().User.customer_ID), archiver_ID: 0, user_type_ID: 1 } }).then(
                res => {
                console.log("DATA: ", res)
                    let SinglePlayer = res.data.users.filter((u) => parseInt(u.user_ID) === parseInt(auth().User.user_ID));
                    setPlayers(SinglePlayer);

                    // This is a player/athlete/patient, automatically set them to be the SelectedPlayer
                    onClickUser(SinglePlayer[0])
                }
            );
        }
        // Optional return function
        // return () => { };
    }, []);

    console.log({Customers})
    console.log({Players})
    console.log(auth().User)

    function WorkoutEntries(props) {
        const { loading, error, data } = useQuery(
            GetUsersQRCodes, 
            {
                variables: { user_ID: SelectedUser.user_ID },
            });
        if (error) return `Error! ${error}`;
        if (loading) {
            return <p>Loading ...</p>;
        } else if (error) {
            return `Error! ${error}`;
        } else if (data.usersQRCodes) {
            let QR_codes_to_save = [];
            let parsedQR = data.usersQRCodes.map((QR) => {
                // If this QR code has not been parsed yet, do so and save the parsed data
                let QR_input = {};

                if(QR.QR_code_parsed === 0) {
                    QR_input.user_QR_code_ID = parseInt(QR.user_QR_code_ID);
                    let SplitArray = QR.QR_code.split(',');
                    let exercise = '';
                    let final_key = '';
                    let is_weight = false;
                    let L_torque = 0;
                    let R_torque = 0;
                    let torque_total = 0;
                    let last_rep_value = '';
                    let set = 1;
                    let set_side_length = '';
                    let set_torque = 0;
                    let side = '';
                    let side_full_word = '';
                    let side_torque_exercise = '';

                    SplitArray.forEach((split, index) => {
                        if(index === 0) {
                            QR_input.exercise_date = split;
                        } else if(index === 1) {
                            QR_input.start_time = split;
                        } else if(index === 2) {
                            QR_input.end_time = split;
                        } else {

                            // Reset the set counter once it gets to 6
                            if(set === 6) set = 1;

                            // Is this index a rep or a weight value
                            is_weight = index % 2 === 0;

                            // 10 indexes per side, per exercise: L1_rep, L1_weight,..., R1_rep, R1_weight...
                            // 3-12 L_supra, 13-22 R_supra, 23-32 L_subscap, 33-42 R_subscap, 43-52 L_infra, 53-62 R_infra, 63-72 L_teres, 73-82 R_teres, 83-92 L_surfer, 93-102 R_surfer
                            if ( index > 2 && index < 23 ) {
                                exercise = 'supra';
                            } else if ( index > 22 && index < 43 ) {
                                exercise = 'subscap';
                            } else if ( index > 42 && index < 63 ) {
                                exercise = 'infra';
                            } else if ( index > 62 && index < 83 ) {
                                exercise = 'teres';
                            } else if ( index > 82 && index < 103 ) {
                                exercise = 'surfer';
                            }

                            // Determine left or right side
                            side = ( index > 2 && index < 13 ) || ( index > 22 && index < 33 ) || ( index > 42 && index < 53 ) ||  ( index > 62 && index < 73 ) || ( index > 82 && index < 93 ) ? `L` : `R`;
                            side_full_word = side === 'L' ? 'left' : 'right';

                            // If this was somehow a negative number, remove the negative sign 
                            split = split.charAt(0) === '-' ? split. replace(/^./, "") : split;

                            // Turn string weights into numbers with tenths decimal place, reps into integers
                            split = is_weight ? parseFloat(split).toFixed(1) : parseInt(split);

                            // If is_weight, we already have this side/set's rep count, use that from the last time through this loop, along with this index's split, to calculate the torque of this set
                            if(is_weight) {

                                // Value of last index / last time through this loop, which is the rep count of this current index's weight value
                                last_rep_value = QR_input[`${side}${set}_rep_${exercise}`];

                                // Create the string for this index's key to go into QR_input object
                                side_torque_exercise = `${side}_torque_${exercise}`;

                                // Calculate the torque for each exercise by side
                                if( exercise === 'supra' ) {

                                    // Get user's arm length for this side, to use in calculation
                                    set_side_length = SelectedUser[`arm_length_${side_full_word}`];

                                    // This set's torque calculation
                                    set_torque = (set_side_length/12)*0.7*last_rep_value*split;

                                } else {
                                
                                    // Get user's forearm length for this side, to use in calculation
                                    set_side_length = SelectedUser[`forearm_length_${side_full_word}`];

                                    // This set's torque calculation
                                    set_torque = (set_side_length/12)*last_rep_value*split;
                                
                                }

                                // The first option needs to be fixed and parsed, somehow the js addition goes wild with decimals without this
                                set_torque = parseFloat(set_torque.toFixed(3));
                                QR_input[`${side}_torque_${exercise}`] = set > 1 ? parseFloat((QR_input[`${side}_torque_${exercise}`]+set_torque).toFixed(3)) : set_torque;

                                // If this is set 5 of the side, turn the torque into a string so it can save as a decimal into the db
                                if( set === 5 ) {
                                    QR_input[`${side}_torque_${exercise}`] = QR_input[`${side}_torque_${exercise}`].toString();
                                }

                                // Continue adding torques to the L, R, and Total torques
                                if ( side === 'L' ) {
                                    L_torque = L_torque !== 0 ? parseFloat((L_torque+set_torque).toFixed(3)) : set_torque;
                                } else if ( side === 'R' ) {
                                    R_torque = R_torque !== 0 ? parseFloat((R_torque+set_torque).toFixed(3)) : set_torque;
                                }
                                torque_total = torque_total !== 0 ? parseFloat((torque_total+set_torque).toFixed(3)) : set_torque;
                            }

                            // Add rep / weight and the exercise to get final_key - Odd index = rep, even index = weight
                            final_key = is_weight ? `${side}${set}_weight_${exercise}` : `${side}${set}_rep_${exercise}`


                            // final_key = ( index > 2 && index < 8 ) || ( index > 12 && index < 18 ) || ( index > 22 && index < 28 ) || ( index > 32 && index < 38 ) || ( index > 42 && index < 48 ) || ( index > 52 && index < 58 ) || 
                            //             ( index > 62 && index < 68 )|| ( index > 72 && index < 78 ) || ( index > 82 && index < 88 ) || ( index > 92 && index < 98 ) ? `${side_set}_rep_${exercise}` : `${side_set}_weight_${exercise}`;
                            // final_key = ( index > 2 && index < 8 ) || ( index > 7 && index < 13 ) || ( index > 12 && index < 18 ) || ( index > 17 && index < 23 ) || ( index > 22 && index < 28 ) || ( index > 27 && index < 33 ) || 
                            //             ( index > 32 && index < 38 ) || ( index > 37 && index < 43 ) || ( index > 42 && index < 48 ) || ( index > 47 && index < 53 ) || ( index > 52 && index < 58 ) || ( index > 57 && index < 63 ) || 
                            //             ( index > 62 && index < 68 ) || ( index > 67 && index < 73 ) || ( index > 72 && index < 78 ) || ( index > 77 && index < 83 ) || ( index > 82 && index < 88 ) || ( index > 87 && index < 93 ) || 
                            //             ( index > 92 && index < 98 ) || ( index > 97 && index < 103 ) ? `${side_set}_rep_${exercise}` : `${side_set}_weight_${exercise}`;


                            // Create QR_input key and value
                            QR_input[final_key] = split;

                            // Up the set counter by 1 every 2 times through this loop
                            set = is_weight ? set+1 : set;
                        }
                    });

                    // Update torque side totals, total. Have to convert the number to a string to save into decimal type for some reason
                    QR_input.L_torque = L_torque.toString();
                    QR_input.R_torque = R_torque.toString();
                    QR_input.torque_total = torque_total.toString();

                    // Push this QR_input object to the QR_codes_to_save array
                    QR_codes_to_save.push(QR_input);
                }

            });

            if(QR_codes_to_save.length > 0) {
                // This will need to be in an async function or a promise to get this data back
                save_user_qr_code({ input: QR_codes_to_save[0] });
            }

            return <WorkoutsCardComponent usersQRCodes={data.usersQRCodes} user_ID={parseInt(SelectedUser.user_ID)} SelectedUser={SelectedUser} />
        }

    }

    // Parse a user's QR Codes if they have not been, and save the results
    async function handleParseQRCodes(usersQRCodes) {
        console.log({usersQRCodes})
        let QR_codes_to_save = [];
        let parsedQR = usersQRCodes.map((QR) => {
            // If this QR code has not been parsed yet, do so and save the parsed data
            let QR_input = {};

            if(QR.QR_code_parsed === 0) {
                QR_input.user_QR_code_ID = parseInt(QR.user_QR_code_ID);
                let SplitArray = QR.QR_code.split(',');
                let exercise = '';
                let final_key = '';
                let is_weight = false;
                let L_torque = 0;
                let R_torque = 0;
                let torque_total = 0;
                let last_rep_value = '';
                let set = 1;
                let set_side_length = '';
                let set_torque = 0;
                let side = '';
                let side_full_word = '';
                let side_torque_exercise = '';

                SplitArray.forEach((split, index) => {
                    if(index === 0) {
                        QR_input.exercise_date = split;
                    } else if(index === 1) {
                        QR_input.start_time = split;
                    } else if(index === 2) {
                        QR_input.end_time = split;
                    } else {

                        // Reset the set counter once it gets to 6
                        if(set === 6) set = 1;

                        // Is this index a rep or a weight value
                        is_weight = index % 2 === 0;

                        // 10 indexes per side, per exercise: L1_rep, L1_weight,..., R1_rep, R1_weight...
                        // 3-12 L_supra, 13-22 R_supra, 23-32 L_subscap, 33-42 R_subscap, 43-52 L_infra, 53-62 R_infra, 63-72 L_teres, 73-82 R_teres, 83-92 L_surfer, 93-102 R_surfer
                        if ( index > 2 && index < 23 ) {
                            exercise = 'supra';
                        } else if ( index > 22 && index < 43 ) {
                            exercise = 'subscap';
                        } else if ( index > 42 && index < 63 ) {
                            exercise = 'infra';
                        } else if ( index > 62 && index < 83 ) {
                            exercise = 'teres';
                        } else if ( index > 82 && index < 103 ) {
                            exercise = 'surfer';
                        }

                        // Determine left or right side
                        side = ( index > 2 && index < 13 ) || ( index > 22 && index < 33 ) || ( index > 42 && index < 53 ) ||  ( index > 62 && index < 73 ) || ( index > 82 && index < 93 ) ? `L` : `R`;
                        side_full_word = side === 'L' ? 'left' : 'right';

                        // If this was somehow a negative number, remove the negative sign 
                        split = split.charAt(0) === '-' ? split. replace(/^./, "") : split;

                        // Turn string weights into numbers with tenths decimal place, reps into integers
                        split = is_weight ? parseFloat(split).toFixed(1) : parseInt(split);

                        // If is_weight, we already have this side/set's rep count, use that from the last time through this loop, along with this index's split, to calculate the torque of this set
                        if(is_weight) {

                            // Value of last index / last time through this loop, which is the rep count of this current index's weight value
                            last_rep_value = QR_input[`${side}${set}_rep_${exercise}`];

                            // Create the string for this index's key to go into QR_input object
                            side_torque_exercise = `${side}_torque_${exercise}`;

                            // Calculate the torque for each exercise by side
                            if( exercise === 'supra' ) {

                                // Get user's arm length for this side, to use in calculation
                                set_side_length = SelectedUser[`arm_length_${side_full_word}`];

                                // This set's torque calculation
                                set_torque = (set_side_length/12)*0.7*last_rep_value*split;

                            } else {
                            
                                // Get user's forearm length for this side, to use in calculation
                                set_side_length = SelectedUser[`forearm_length_${side_full_word}`];

                                // This set's torque calculation
                                set_torque = (set_side_length/12)*last_rep_value*split;
                            
                            }

                            // The first option needs to be fixed and parsed, somehow the js addition goes wild with decimals without this
                            set_torque = parseFloat(set_torque.toFixed(3));
                            QR_input[`${side}_torque_${exercise}`] = set > 1 ? parseFloat((QR_input[`${side}_torque_${exercise}`]+set_torque).toFixed(3)) : set_torque;

                            // If this is set 5 of the side, turn the torque into a string so it can save as a decimal into the db
                            if( set === 5 ) {
                                QR_input[`${side}_torque_${exercise}`] = QR_input[`${side}_torque_${exercise}`].toString();
                            }

                            // Continue adding torques to the L, R, and Total torques
                            if ( side === 'L' ) {
                                L_torque = L_torque !== 0 ? parseFloat((L_torque+set_torque).toFixed(3)) : set_torque;
                            } else if ( side === 'R' ) {
                                R_torque = R_torque !== 0 ? parseFloat((R_torque+set_torque).toFixed(3)) : set_torque;
                            }
                            torque_total = torque_total !== 0 ? parseFloat((torque_total+set_torque).toFixed(3)) : set_torque;
                        }

                        // Add rep / weight and the exercise to get final_key - Odd index = rep, even index = weight
                        final_key = is_weight ? `${side}${set}_weight_${exercise}` : `${side}${set}_rep_${exercise}`


                        // final_key = ( index > 2 && index < 8 ) || ( index > 12 && index < 18 ) || ( index > 22 && index < 28 ) || ( index > 32 && index < 38 ) || ( index > 42 && index < 48 ) || ( index > 52 && index < 58 ) || 
                        //             ( index > 62 && index < 68 )|| ( index > 72 && index < 78 ) || ( index > 82 && index < 88 ) || ( index > 92 && index < 98 ) ? `${side_set}_rep_${exercise}` : `${side_set}_weight_${exercise}`;
                        // final_key = ( index > 2 && index < 8 ) || ( index > 7 && index < 13 ) || ( index > 12 && index < 18 ) || ( index > 17 && index < 23 ) || ( index > 22 && index < 28 ) || ( index > 27 && index < 33 ) || 
                        //             ( index > 32 && index < 38 ) || ( index > 37 && index < 43 ) || ( index > 42 && index < 48 ) || ( index > 47 && index < 53 ) || ( index > 52 && index < 58 ) || ( index > 57 && index < 63 ) || 
                        //             ( index > 62 && index < 68 ) || ( index > 67 && index < 73 ) || ( index > 72 && index < 78 ) || ( index > 77 && index < 83 ) || ( index > 82 && index < 88 ) || ( index > 87 && index < 93 ) || 
                        //             ( index > 92 && index < 98 ) || ( index > 97 && index < 103 ) ? `${side_set}_rep_${exercise}` : `${side_set}_weight_${exercise}`;


                        // Create QR_input key and value
                        QR_input[final_key] = split;

                        // Up the set counter by 1 every 2 times through this loop
                        set = is_weight ? set+1 : set;
                    }
                });

                // Update torque side totals, total. Have to convert the number to a string to save into decimal type for some reason
                QR_input.L_torque = L_torque.toString();
                QR_input.R_torque = R_torque.toString();
                QR_input.torque_total = torque_total.toString();

                // Push this QR_input object to the QR_codes_to_save array
                QR_codes_to_save.push(QR_input);
            }

        });

        if(QR_codes_to_save.length > 0) {
            // This will need to be in an async function or a promise to get this data back
            await save_user_qr_code({ input: QR_codes_to_save[0] });
            // Tell this function's caller that we updated data so we need to refetch
            return true;
        } else {
            return false;
        }
    }

    // Handler for clicking a user in the list of players
    async function onClickUser(user) {
    
        if ( parseInt(user.user_ID) > 0 ) {
            // Get the Benchmark entries for this user
            let TempPTCs = await get_users_PTCs({ variables: { user_ID: parseInt(user.user_ID) } });
            console.log({TempPTCs});

            // Set this User's PTCs, otherwise if there are none or there was an issue, set them to an empty array
            if ( TempPTCs.data && TempPTCs.data.usersPTCs ) {
                setSelectedUserPTCs([ ...TempPTCs.data.usersPTCs ]);
            } else {
                setSelectedUserPTCs([]);
            }

            // Set this User's QR Codes
            let TempQRCodes = await get_users_QRCodes({ variables: { user_ID: parseInt(user.user_ID) } });
            console.log({TempQRCodes});

            // Set this User's PTCs, otherwise if there are none or there was an issue, set them to an empty array
            if ( TempQRCodes.data && TempQRCodes.data.usersQRCodes ) {
                let need_to_refetch = await handleParseQRCodes(TempQRCodes.data.usersQRCodes);
                if ( need_to_refetch ) {
                    TempQRCodes = await get_users_QRCodes({ variables: { user_ID: parseInt(user.user_ID) } });
                    if ( TempQRCodes.data && TempQRCodes.data.usersQRCodes ) {
                        setSelectedUserQRCodes([ ...TempQRCodes.data.usersQRCodes ]);
                    } else {
                        setSelectedUserQRCodes([]);
                    }
                } else {
                    setSelectedUserQRCodes([ ...TempQRCodes.data.usersQRCodes ]);
                }
            } else {
                setSelectedUserQRCodes([]);
            }

            // Update the action and SelectedUser
            setAction(''); 
            setSelectedUser({...user});
        } else {
        
            // Add a Player clicked
            setAction('add_player');
            setSelectedUser({...DefaultUser});
            setSelectedUserPTCs([]);
            setSelectedUserQRCodes([]);
        }

    }

    // Handler for refreshing player list. Takes a user_ID argument to make this user the SelectedUser after new list is received.
    async function refreshPlayerListAfterAdd(user) {
        let TempPlayers = [...Players];
        TempPlayers.unshift(user);
        setPlayers([...TempPlayers]);
        setAction(''); 
        setSelectedUser({...user});
    }

    // Table listing Players
    function PlayersList(PlayersListProps) {
        return (
            <>
                <table className="table table-striped table-hover">
                    <thead className="h6">
                        <tr className="row">
                            <th className={`col-4 ${auth().User.user_type_ID === 1 && 'ps-3'}`}>
                                {auth().User.user_type_ID === 1 && ((parseInt(auth().User.athletic) === 1 && 'Player') || 'Patient')}
                                {auth().User.user_type_ID !== 1 && ((parseInt(auth().User.athletic) === 1 && 'Players') || 'Patients')}
                            </th>
                            <th className="col-4">Last Workout</th>
                            <th className="col-4">Last Benchmark</th>
                        </tr>
                    </thead>
                    {
                        (PlayersListProps.TempPlayers.length > 0 || Action === 'add_player') &&
                        <tbody className="">
                            {Action === 'add_player' &&
                                <>
                                    <tr className="row">
                                        <td className="col-12">
                                            <span className="float-start">
                                                <button className="btn btn-sm fw-bolder text-secondary border border-secondary border-3 me-2" onClick={() => { setAction(''); setSelectedUser({...DefaultUser});}}><FontAwesomeIcon icon="fa-times" className="me-2" />Cancel</button>
                                            </span>
                                            <span className="float-start mt-2 h5">
                                                Enter new player details below
                                            </span>
                                        </td>
                                    </tr>
                                    <tr className="row" key="0">
                                        <td colSpan="3">
                                            <div className="row" ref={playerRef}>
                                                <div className="col-12 mb-4">
                                                    <PlayerCardComponent Player={SelectedUser} editing={true} refreshPlayerListAfterAdd={(user) => refreshPlayerListAfterAdd(user)} card_open={CardOpenPlayerDetails} setCardOpenPlayerDetails={(value) => setCardOpenPlayerDetails(value)}/>
                                                </div>
                                                <div className="col-12 mb-4">
                                                    <WorkoutsCardComponent playerRef={playerRef} usersQRCodes={SelectedUserQRCodes} user_ID={parseInt(SelectedUser.user_ID)} SelectedUser={SelectedUser} setAction={(action) => setAction(action)} Action={Action} card_open={CardOpenWorkouts} setCardOpenWorkouts={(value) => setCardOpenWorkouts(value)} />
                                                </div>
                                                <div className="col-12 mb-4">
                                                    <BenchmarksCardComponent playerRef={playerRef} PTCs={SelectedUserPTCs} SelectedUser={SelectedUser} setAction={(action) => setAction(action)} Action={Action} card_open={CardOpenBenchmarks} setCardOpenBenchmarks={(value) => setCardOpenBenchmarks(value)} />
                                                </div>
                                            </div>

                                            {/* <div className="row row-cols-xxl-3 row-cols-xl-3 row-cols-md-2 row-cols-1">
                                                <div className="col mb-4">
                                                    <PlayerCardComponent Player={SelectedUser} editing={true} refreshPlayerListAfterAdd={(user) => refreshPlayerListAfterAdd(user)} />
                                                </div>
                                                <div className="col mb-4">
                                                    <WorkoutEntries {...props} />
                                                </div>
                                                <div className="col mb-4">
                                                    <BenchmarksCardComponent PTCs={SelectedUserPTCs} SelectedUser={SelectedUser} />
                                                </div>
                                            </div> */}
                                        </td>
                                    </tr>
                                </>
                            }
                            {PlayersListProps.TempPlayers.map((u) => {
                                console.log({u})
                                return (
                                    <React.Fragment key={u.user_ID}>
                                        <tr className="row">
                                            <td className="col-4">
                                                <span className="float-start">
                                                    {
                                                        auth().User.user_type_ID !== 1 &&
                                                        (
                                                            (parseInt(SelectedUser.user_ID) === parseInt(u.user_ID) && 
                                                            <button className={`btn btn-sm fw-bolder text-secondary border border-secondary border-3 me-2 ${u.player_position !== '' || (u.player_number !== '' && u.player_number !== null ) && 'mt-2'}`} onClick={() => { setAction(''); setSelectedUser({...DefaultUser});}}><FontAwesomeIcon icon="fa-times" className="me-2" />Close</button>)
                                                            || <button className={`btn btn-sm fw-bolder text-primary border border-primary border-3 me-2 ${u.player_position !== '' || (u.player_number !== '' && u.player_number !== null ) && 'mt-2'}`} onClick={() => onClickUser(u)}><FontAwesomeIcon icon="fa-user-pen" className="me-2" />Profile</button>
                                                        )
                                                    }
                                                </span>
                                                <span className={`float-start ${auth().User.user_type_ID === 1 && 'ms-2'}`}>
                                                    {u.last_name}, {u.first_name}{(u.player_position !== '' || (u.player_number !== '' && u.player_number !== null )) && <br />}
                                                    {u.player_position !== '' && <span>{u.player_position}{u.player_number !== '' && u.player_number !== null && <span>, </span>}</span>}{u.player_number !== '' && <span>{u.player_number}</span>}
                                                </span>
                                            </td>
                                            <td className="col-4">
                                                {u.date_last_workout !== null && 
                                                    <span>
                                                        {(window.innerWidth > 1000 && dayjs(u.date_last_workout).format('dddd M-D-YY')) || 
                                                        <span>{dayjs(u.date_last_workout).format('dddd')}<br />{dayjs(u.date_last_workout).format('M-D-YY')}</span>}
                                                    </span>}
                                                {u.date_last_workout == null && <span className="h5"><span className="badge rounded-pill border border-danger bg-white text-danger">{ (window.innerWidth > 1000 && 'No Workouts Recorded') || 'None'}</span></span>}
                                            </td>
                                            <td className="col-4">
                                                {u.date_last_benchmark !== null && 
                                                    <span>
                                                        {(window.innerWidth > 1000 && dayjs(u.date_last_benchmark).format('dddd M-D-YY')) || 
                                                        <span>{dayjs(u.date_last_benchmark).format('dddd')}<br />{dayjs(u.date_last_benchmark).format('M-D-YY')}</span>}
                                                    </span>}
                                                {u.date_last_benchmark == null && <span className="h5"><span className="badge rounded-pill border border-danger bg-white text-danger">{ (window.innerWidth > 1000 && 'No Benchmarks Recorded') || 'None'}</span></span>}
                                            </td>
                                            {
                                                parseInt(SelectedUser.user_ID) === parseInt(u.user_ID) &&
                                                // (
                                                //     (Action === 'view_player' &&
                                                <>
                                                {/* <td colSpan="3">
                                                    <WorkoutsGraphComponent />
                                                </td> */}
                                                <td colSpan="3">
                                                    {
                                                        Action === 'benchmark_graph' &&
                                                        <BenchmarksGraphComponent Benchmarks={SelectedUserPTCs} Workouts={SelectedUserQRCodes} />
                                                    }
                                                    {
                                                        Action === 'workout_graph' &&
                                                        <WorkoutsGraphComponent Workouts={SelectedUserQRCodes} />
                                                    }
                                                    {/* <div className="row row-cols-xxl-3 row-cols-xl-2 row-cols-lg-1 row-cols-md-1 row-cols-1" ref={playerRef}> */}
                                                    <div className="row" ref={playerRef}>
                                                        <div className="col-12 mb-4">
                                                            <PlayerCardComponent Player={SelectedUser} editing={false} refreshPlayerListAfterAdd={(user) => refreshPlayerListAfterAdd(user)} card_open={CardOpenPlayerDetails} setCardOpenPlayerDetails={(value) => setCardOpenPlayerDetails(value)}/>
                                                        </div>
                                                        <div className="col-12 mb-4">
                                                            <WorkoutsCardComponent playerRef={playerRef} usersQRCodes={SelectedUserQRCodes} user_ID={parseInt(SelectedUser.user_ID)} SelectedUser={SelectedUser} setAction={(action) => setAction(action)} Action={Action} card_open={CardOpenWorkouts} setCardOpenWorkouts={(value) => setCardOpenWorkouts(value)} />
                                                        </div>
                                                        <div className="col-12 mb-4">
                                                            <BenchmarksCardComponent playerRef={playerRef} PTCs={SelectedUserPTCs} SelectedUser={SelectedUser} setAction={(action) => setAction(action)} Action={Action} card_open={CardOpenBenchmarks} setCardOpenBenchmarks={(value) => setCardOpenBenchmarks(value)} />
                                                        </div>
                                                    </div>
                                                </td>
                                                </>
                                                //     )
                                                // )
                                            }
                                        </tr>
                                    </React.Fragment>
                                )
                            })}
                        </tbody>
                    }
                </table>
            </>
        );
    } 
    console.log({Action})
    // Header content for Filters and Add Player button
    function HeaderContent() {
        return (
            <div className="clearfix">

                {/* ADD TOOLING BUTTON */}
                <div className="float-end">
                    <button 
                        className="btn fw-bold col-auto border-primary border-3 float-end text-primary" 
                        onClick={() => onClickUser(DefaultUser)}
                        disabled={SelectedUser.user_ID === 0 && Action === 'add_player'}
                    >
                        <FontAwesomeIcon icon="fa-user-plus" className="me-2" />Add Player
                    </button>
                </div>

            </div>
        )
    }
    console.log({props});
    console.log({SelectedUser})
    console.log({SelectedUserQRCodes})
    
    return (
        <div className="">
            {
                parseInt(auth().User.customer_ID) !== 1 &&
                <>
                    {/* Only shoe 'Add Player' to non-players */}
                    {auth().User.user_type_ID !== 1 && <HeaderContent />}
                    { 
                        ( Players.length > 0 || Action === 'add_player' ) &&
                        <PlayersList TempPlayers={Players} />
                    }      
                </> 
            }
            {
                parseInt(auth().User.customer_ID) === 1 && Customers.length > 0 &&
                Customers.map((C) => {
                    if ( parseInt(C.customer_ID) !== 1 ) {
                        return (
                            <div className="card h-100 mb-5" key={parseInt(C.customer_ID)}>
                                <div className="card-header h5 border border-secondary">
                                    <div className="clearfix">
                                        <span className="float-start mt-1">{C.customer_name}</span>
                                    </div>
                                </div>
                                <div className="card-body border border-secondary border-top-0">
                                    <PlayersList TempPlayers={C.Players} />
                                </div>
                            </div>
                        )
                    }
                })
            }
            { 
                Players.length === 0 && Action === '' &&
                <div className="alert alert-info mt-2">No Athletes available - Add a new Player account.</div>
            }
            {
                !Players &&
                <LoadingContent />
            }       
        </div>
    )
}

// export const PlayersListComponent = compose(
// 	queryWithLoading({
// 		gqlString: GetUsers,
//         name: "Players",
//         variablesFunction: (props) => console.log({props}) || ({company_ID: 0})
// 	})
// )(PlayersListContent)

	// withMutation(ToolingSaveMutation, "ToolingSaveMutation", [{query: getToolingQuery}]),
